import type { TemplateOnlyComponent } from '@ember/component/template-only';
import { concat } from '@ember/helper';
import { on } from '@ember/modifier';
import t from 'ember-intl/helpers/t';
import type CnamContext from 'parog-web/contexts/abstract/cnam-context';
import AnimatedSuccessIcon from 'ui-kit/components/animated-success-icon';
import Button from 'ui-kit/components/button';

export default <template>
  <div class='mt-0 w-full p-4 text-center' data-test-success>
    <div class='header'>
      <AnimatedSuccessIcon />
      {{#if (has-block 'title')}}
        {{yield to='title'}}
      {{else}}
        <h2>
          {{t
            (concat
              'cnam-services-access-form.success.title.' @context.successKey
            )
          }}
        </h2>
      {{/if}}

    </div>
    <span data-test-success-message>
      {{#if (has-block 'content')}}
        {{yield to='content'}}
      {{else}}
        {{t
          (concat 'cnam-services-access-form.success.text.' @context.successKey)
        }}
      {{/if}}
    </span>
  </div>
  <Button
    type='button'
    class='ui fluid form-button'
    data-test-close-success-modal
    {{on 'click' @onDismiss}}
  >
    {{#if @dismissText}} {{@dismissText}} {{else}} Fermer{{/if}}
  </Button>
</template> satisfies TemplateOnlyComponent<{
  Args: {
    context: CnamContext;
    onDismiss: () => void;
    dismissText?: string;
  };
  Blocks: {
    title: [];
    content: [];
  };
}>;
